import { SyntheticEvent, useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../../api/queries/user/useUser";
import { Button } from "primereact/button";
import { usePlacementEnvironmentTemplates } from "../../api/queries/placement-environment-template/usePlacementEnvironmentTemplates";
import { userContext } from "../../context/user";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { CreatePlacementEnvironmentPayload } from "../../api/types/placement-environment";
import { useCreatePlacementEnvironment } from "../../api/queries/placement-environment/useCreatePlacementEnvironment";
import { useQueryClient } from "react-query";
import { defaultInvalidateQueryFilters, queryKeys } from "../../api/query";

export default function UserPlacementEnvironmentComponent() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { uuid } = useParams();
  const { detail } = useContext(userContext);
  const { data: user } = useUser(detail?.id);
  const { data: PETemplates } = usePlacementEnvironmentTemplates({
    limit: 99,
    offset: 0,
    fContextId: user?.data.personal_information.context?.id || "",
  });

  const createPlacementEnvironment = useCreatePlacementEnvironment();

  const [template, setTemplate] = useState<string>("");
  const onTemplateChange = (event: DropdownChangeEvent) =>
    setTemplate(event.value);

  const onSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!uuid || !template) {
      return;
    }

    const payload: CreatePlacementEnvironmentPayload = {
      placement_environment_template_id: template,
      user_id: uuid,
    };

    await createPlacementEnvironment.mutateAsync(payload);

    queryClient.invalidateQueries(
      queryKeys.user(uuid),
      defaultInvalidateQueryFilters,
    );

    navigate(`/users/${uuid}`);
  };

  return (
    <form className="col-12 mt-3" onSubmit={onSubmit}>
      <div className="p-fluid">
        <div className="field pt-3">
          <div className="p-float-label">
            <Dropdown
              options={PETemplates?.data.results || []}
              value={template}
              onChange={onTemplateChange}
              optionLabel="name"
              optionValue="id"
            />
            <label>Template</label>
          </div>
        </div>
      </div>

      <div className="text-right">
        <Button label="Save" className="p-button-sm p-button-main" />
      </div>
    </form>
  );
}
